import React from "react";

import { SwiperSlide } from "swiper/react";
import Carousel from "../carousel/carousel";
import Banner from "../../molecules/banner/banner";

import "./banner-carousel.scss";

const carouselConfig = {
	slidesPerView: 1,
	spaceBetween: 0,
	centeredSlides: true,
	initialSlide: 1,
	height: 600,
	navigation: true,
	pagination: true,
	watchOverflow: true
};


const BannerCarousel = (props) => {

	const {
		slides,
	} = props;
	
	return (

		<div className="banner-carousel" id="home">

			<Carousel config={carouselConfig}>

				{slides.map((item, index) => {

					return (
						<SwiperSlide 
							key={index} 
							effect="fade">

							<Banner 
								content={item}>					
							</Banner>
							
						</SwiperSlide>
					);

				})}

			</Carousel>

		</div>

	);
};

export default BannerCarousel;
